import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по ссылке «Смотреть проекты серии» в блоке Серия Плюс.
 */
export function trackSeriaPlusWatchProjectsClick(): void {
  ca('eventSite', {
    action: 'click_seria_plus_watch_projects',
    category: 'Promo',
    label: 'watch_projects_link',
    name: 'oldevent',
    products: [createDeveloperProduct()],
  });
}
